module.exports = __webpack_public_path__ + "img/what-is-logo.7b36c87c.png";